export default __webpack_public_path__ + "static/media/PSO 03 - Amarração de Cargas - WestRock.4304b57f.pdf";